<template>
    <div class="pt-8">
        <FilterForm 
            :filter="filter" 
            @get-users-list="getUsersList()" 
            @clear-filter-form="clearFilterForm()" 
        />
        <UsersTable 
            :users="usuarios" 
            :paginator="paginator" 
            :pageSize="pageSize" 
            :canResetPassword="canResetPassword" 
            :canSuperviseSalesComission="canSuperviseSalesComission"
            @get-users-list="getUsersList()" 
            @change-page="changePage($event)" 
            @open-reset-pass-modal="openChildReset($event)"
            
        />
        <passwordReset @close-modal="closeChildReset" :openModal="modalReset" :user="userReset"/>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import passwordReset from '../components/UserPassword.vue'
import FilterForm from '../components/FilterForm.vue'
import UsersTable from '../components/UsersTable.vue'
export default {
    computed: {
        ...mapState('auth', ['user'])
    },
    data(){
        return{
            usuarios: [],
            filter: {
                nombre: "",
                email: "",
                telefono: "",
            },
            canResetPassword: false,
            canSuperviseSalesComission: false,
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            modalReset: false,
            userReset: {},
            pageSize: [10, 25, 50, 100],
            pageOptions: "",
        }
    },
    components: {
        passwordReset,
        FilterForm,
        UsersTable
    },
    created(){
        this.getUsersList();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getUsersList(){
            this.pageOptions = {
                pageNumber: this.paginator.page, 
                pageSize:   this.paginator.pageSize,
                nombre:     this.filter.nombre,
                email:      this.filter.email,
                telefono:   this.filter.telefono
            }
            if(this.user.permissions.includes('can_reset_users_password')){
                this.canResetPassword = true;
            }
            if(this.user.permissions.includes('can_supervise_sales_comission')){
                this.canSuperviseSalesComission = true;
            }
            this.setLoading(true)
            await this.$conectar.post('/user/get-users-list', this.pageOptions)
            .then(response =>{
                this.usuarios = response.data.users;
                this.paginator.totalPage = response.data.totalPages;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        changePage(page){
            this.paginator.page = page;
            this.getUsersList();
        },
        clearFilterForm(){
            this.filter.nombre = "";
            this.filter.email = "";
            this.filter.telefono = "";
            this.paginator.pageSize = 10;
        },
        openChildReset(user){
            this.modalReset = true;
            this.userReset = user;
        },
        closeChildReset(){
            this.modalReset = false;
            this.userReset = {};
        }
    }
}
</script>